<div class="top-content-container create-dashboard-widget-form-content">
  <!-- Widget Type Selection -->
  <div class="widget-types" *ngIf="showWidgetTypeSelection">
    <button
      mat-stroked-button
      class="widget-type-button"
      *ngFor="let type of widgetTypes"
      [class.selected]="type.id === selectedWidgetType"
      (click)="selectWidgetType(type.id)"
    >
      <wlm-icon [icon]="type.icon" [color]="widgetTypeIconColor"></wlm-icon>
      <div class="custom-panel-header">
        {{ T_SCOPE + '.widget-types.' + type.labelKey | translate }}
      </div>
    </button>
  </div>
  <div class="content-container">
    <div class="left-panel">
      <!-- Selection Panels -->
      <div class="selection-panels">
        <!-- Scenarios -->
        <div class="panel scenarios-panel">
          <div class="panel-content">
            <mat-checkbox
              *ngFor="let scenario of scenarioOptions"
              [(ngModel)]="scenario.selected"
              (ngModelChange)="onFiltersChange()"
            >
              {{ scenario.label }}
            </mat-checkbox>
          </div>
        </div>

        <!-- NETs -->
        <div class="panel elements-panel">
          <div class="map-separator"></div>
          <div class="custom-panel-header">
            {{ T_SCOPE + '.network-element-types' | translate }}
          </div>
          <div class="panel-content">
            <cdk-virtual-scroll-viewport [itemSize]="itemSize" class="scroll-viewport">
              <div *cdkVirtualFor="let item of networkElementTypeOptions" class="simulation-item">
                <mat-checkbox [(ngModel)]="item.selected" (ngModelChange)="onFiltersChange()">
                  <wlm-svg
                    class="svg-icon filter-item-option-icon"
                    [style.height]="defaultIconSize + 'px'"
                    [style.width]="defaultIconSize + 'px'"
                    [width]="defaultIconSize"
                    [height]="defaultIconSize"
                    [path]="item.icon"
                  ></wlm-svg>
                  {{ item.label }}
                </mat-checkbox>
              </div>
            </cdk-virtual-scroll-viewport>
          </div>
        </div>
      </div>
    </div>

    <div class="center-panel">
      <ct-attributes-selector
        [filters]="filters"
        [existingNetworkElements]="existingNetworkElements"
        (addAttributesToCart)="onAddAttributesToCart($event)"
        (addMeasurementToCart)="onAddMeasurementToCart($event)"
      ></ct-attributes-selector>
    </div>

    <div class="right-panel">
      <!-- Cart -->
      <ct-create-dashboard-widget-cart
        [widgetType]="selectedWidgetType"
        [disableAddToDashboard]="disableAddToDashboard"
        [existingNetworkElements]="existingNetworkElements"
        (onNetworkElementsChange)="onNetworkElementChange($event)"
        (cartSelectionSubmit)="onCartSelectionSubmit($event)"
      ></ct-create-dashboard-widget-cart>
    </div>
  </div>
</div>
